// extracted by mini-css-extract-plugin
export var absolute = "Person-module--absolute--a6939";
export var accordion = "Person-module--accordion--74052";
export var accordionPanel = "Person-module--accordionPanel--71909";
export var active = "Person-module--active--a898a";
export var bio = "Person-module--bio--ff738";
export var button = "Person-module--button--a6d50";
export var buttons = "Person-module--buttons--1547e";
export var card = "Person-module--card--ece12";
export var chevron = "Person-module--chevron--ee2bb";
export var content = "Person-module--content--00f35";
export var dropdown = "Person-module--dropdown--a114b";
export var heading = "Person-module--heading--7f04b";
export var image = "Person-module--image--fbb15";
export var info = "Person-module--info--7423e";
export var innotransButton = "Person-module--innotrans-button--6f467";
export var innotransCard = "Person-module--innotrans-card--8f7a4";
export var innotransImage = "Person-module--innotrans-image--34467";
export var isCampaign = "Person-module--is-campaign--1f050";
export var large = "Person-module--large--4c28c";
export var metadata = "Person-module--metadata--7181d";
export var modal = "Person-module--modal--958b3";
export var name = "Person-module--name--dd668";
export var noimage = "Person-module--noimage--eb357";
export var overlay = "Person-module--overlay--07d0a";
export var person = "Person-module--person--c0fed";
export var socialIcon = "Person-module--social-icon--a6e5a";
export var tag = "Person-module--tag--ab499";
export var title = "Person-module--title--63c6c";
export var top = "Person-module--top--6beaf";